// extracted by mini-css-extract-plugin
export default {"Title":"styles_Title__XHVEL","Subtitle":"styles_Subtitle__4AlYD","Container":"styles_Container__65gu-","input":"styles_input__CS378","inputError":"styles_inputError__nC-Nb"};